import { render, staticRenderFns } from "./skeleton_note.vue.js?vue&type=template&id=f7437d74!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./skeleton_note.vue?vue&type=template&id=f7437d74"
import script from "./skeleton_note.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./skeleton_note.vue?vue&type=script&lang=js"
export * from "./skeleton_note.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./skeleton_note.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports